import React from 'react';
import { X } from 'lucide-react';
import { Button } from './Button';

/** 학생·시험지 상세와 같은 우측 닫기 버튼. 모바일에서는 아이콘만 표시한다. */
export default function PanelCloseButton({ onClose, className = '', ...props }) {
  return (
    <Button {...props} type="button" variant="ghost" size="sm" onClick={onClose}
      className={`ml-auto flex w-auto shrink-0 items-center justify-center gap-1 md:w-[90px] ${className}`} aria-label="닫기">
      <X className="size-4" aria-hidden="true" />
      <span className="hidden md:inline">닫기</span>
    </Button>
  );
}
